const leaflets = {
    "despar": {
        "config": {
            "primary-color": "rgb(217, 4, 16)",
            "secondary-color": "rgb(2, 95, 47)",
            "tertiary-color": "rgb(99, 44, 56)",
            "hover-color": "rgba(220, 35, 17, 0.5)",
            "clientIcon": require("assets/images/logo_eurospar.png"),
            "serverPath": "maiora.volantinointerattivo.net/",
            "pdfPath": "/media/pdf/volantino.pdf",
            "shareFlyerTitle": "Dai uno sguardo al nuovo volantino di Despar!",
            "shareFlyerURL": "https://maiora.volantinointerattivo.net?v=120",
            "shareProductSentence": "Guarda questa fantastica offerta!",
            "ogTitleMeta": "Volantino Interattivo Despar",
            "ogDescriptionMeta": "Dai uno sguardo al nostro nuovo volantino.",
            "ogImageMeta": "https://maiora.volantinointerattivo.net/media/images/despar_fb.png",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": false,
            "ga_tracking_id": "UA-152069090-17",
            "release_id": "1",
            "send_grocery_list_to_market": false,
            "grocery_list_min_value": 20,
            "client_id": 3,
            "signboard_id": 10,
            "has_pages": true,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "line_through": false,
            "category_banner": "/media/images/banner.png",
            "hide_plus_product": false,
            "hide_plus_product_price": false,
            "type": "leaflet",
            "version": 120
        },
        "video": {
            "show_only_once": true,
            "mandatory_seconds": 4,
            "videos": [
                {
                    page: 1,
                    url: "/media/video/Despar1.mp4",
                    item_id: "185218"
                },
            ],
        },
        "leaflet": {
            "name": "Demo Despar",
            "code": "120",
            "id_campaign": "120",
            "index": {
                "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/Indice_DeSpar_SxR6kd8.png",
                "links": [
                    {
                        "page": 2,
                        "blueprint": {
                            "top": 25.388994717495528,
                            "left": 8.044449422340351,
                            "width": 84.01747571457975,
                            "height": 5.778690956810434
                        }
                    },
                    {
                        "page": 4,
                        "blueprint": {
                            "top": 31.25566565444608,
                            "left": 8.262707785205473,
                            "width": 84.01747571457975,
                            "height": 5.778690956810434
                        }
                    },
                    {
                        "page": 6,
                        "blueprint": {
                            "top": 37.14086779349346,
                            "left": 8.371088883966927,
                            "width": 84.01747571457975,
                            "height": 5.778690956810434
                        }
                    },
                    {
                        "page": 8,
                        "blueprint": {
                            "top": 42.99158090426336,
                            "left": 8.377059562482104,
                            "width": 84.01747571457975,
                            "height": 5.778690956810434
                        }
                    },
                    {
                        "page": 10,
                        "blueprint": {
                            "top": 49.038420729725374,
                            "left": 8.53913481931916,
                            "width": 84.01747571457975,
                            "height": 5.778690956810434
                        }
                    },
                    {
                        "page": 12,
                        "blueprint": {
                            "top": 54.954506999142374,
                            "left": 8.274145759503869,
                            "width": 84.01747571457975,
                            "height": 5.778690956810434
                        }
                    },
                    {
                        "page": 14,
                        "blueprint": {
                            "top": 60.805220109912256,
                            "left": 8.0524196489297,
                            "width": 84.01747571457975,
                            "height": 5.778690956810434
                        }
                    },
                    {
                        "page": 16,
                        "blueprint": {
                            "top": 67.02141051078664,
                            "left": 8.2204585928551,
                            "width": 84.01747571457975,
                            "height": 5.778690956810434
                        }
                    },
                    {
                        "page": 19,
                        "blueprint": {
                            "top": 72.80211766238521,
                            "left": 8.170246165342213,
                            "width": 84.01747571457975,
                            "height": 5.778690956810434
                        }
                    },
                    {
                        "page": -1,
                        "type": "url",
                        "url": "https://volantinointerattivo.net",
                        "target": "_blank",
                        "blueprint": {
                            "top": 4.7136157098097105,
                            "left": 66.61469807838508,
                            "width": 28.975,
                            "height": 7.904923009897247
                        }
                    },
                    {
                        "page": -1,
                        "type": "url",
                        "url": "https://despar.com",
                        "target": "_blank",
                        "blueprint": {
                            "top": 3.9771139189044376,
                            "left": 6.971121383842829,
                            "width": 44.339916773367484,
                            "height": 9.230628660964433
                        }
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Self Service",
                    "subcategories": [
                        "Latte",
                        "Yogurt",
                        "Formaggi",
                        "Salumi",
                        "Pasta"
                    ]
                },
                {
                    "category_name": "Alimentari",
                    "subcategories": [
                        "Dispensa",
                        "Colazione",
                        "Snack Dolci",
                        "Pasta",
                        "Snack Salati"
                    ]
                },
                {
                    "category_name": "Surgelati",
                    "subcategories": [
                        "Verdure"
                    ]
                },
                {
                    "category_name": "Pet",
                    "subcategories": [
                        "Food"
                    ]
                },
                {
                    "category_name": "Gastronomia",
                    "subcategories": [
                        "Salumi",
                        "Formaggi"
                    ]
                },
                {
                    "category_name": "Macelleria",
                    "subcategories": [
                        "Avicoli",
                        "Bovino",
                        "Suino"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_1_MCT0Vlb.jpg",
                    "products": [
                        {
                            "item_id": "51659",
                            "field1": "Latte Parzialmente scremato UHT",
                            "field2": "PARMALAT",
                            "field3": "brick 1l",
                            "field4": "",
                            "description": "Latte Parzialmente scremato UHT PARMALAT brick 1l",
                            "grammage": null,
                            "price": "0.68",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 38.24340754715084,
                                "left": 2.8453480113636362,
                                "width": 40.18915121588909,
                                "height": 52.85129719489511
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/Parmalat_latte_parzialmente_scremato_Brick_1_lt__1456400700_14576858_NYMlwal.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_2UAq72x_MoKSVdl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Parmalat",
                                    "data": {
                                        "titolo": "Parmalat",
                                        "testo": "Il latte Bontà e Linea UHT è il latte parzialmente scremato per nutrirsi ogni giorno con leggerezza. Per realizzarlo Parmalat seleziona il miglior latte e lo sottopone a severi controlli. Il trattamento termico UHT, che consiste nel riscaldare il latte a temperatura elevata per pochi secondi, consente al prodotto una lunga durata. Con questo sistema, infatti, il latte si conserva per oltre tre mesi a temperatura ambiente, mantenendo praticamente inalterati il valore nutritivo e le caratteristiche organolettiche.\n(fonte: parmalat.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/GapcmvcfAb/images/Schermata_2020-09-07_alle_12.23.15.png"
                                        ]
                                    }
                                }
                            ],
                            "related": ["51729", "cstm26920027"]
                        },
                        {
                            "item_id": "62113",
                            "field1": "olio extra vergine ",
                            "field2": "di oliva classico",
                            "field3": "monini",
                            "field4": "1l",
                            "description": "olio extra vergine  di oliva classico monini 1l",
                            "grammage": null,
                            "price": "2.97",
                            "price_label": "€ 2,97",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 41.588402727902334,
                                "left": 37.26685875618812,
                                "width": 34.024257425742576,
                                "height": 48.62948398142923
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/Monini_extra_vergine_oliva_Lt_1_1455534094.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_kIGdFyf_u9JEOLF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "title": "Informazioni nutrizionali",
                                    "data": {
                                        "specifiche": "valore energetico 822 kcal - 3378 kJ, Grassi 91,3 g, di cui acidi grassi saturi 13,2 g, acidi grassi monoinsaturi 66,6 g, acidi grassi polinsaturi 6,9 g, Carboidrati 0,0 g, di cui zuccheri 0,0 g, Proteine 0,0 g, Sale 0,0 g (fonte: cosicomodo.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/GapcmvcfAb/images/Monini_extra_vergine_oliva_Lt_1_1455534094.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm33272542",
                            "field1": "Pancarrè ",
                            "field2": "Despar x 20 fette",
                            "field3": "330 g",
                            "field4": "",
                            "description": "Pancarrè  Despar x 20 fette 330 g",
                            "grammage": 330,
                            "price": "0.24",
                            "price_label": "€ 0,24",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 24.09034796575319,
                                "left": 72.04587336697743,
                                "width": 24.397425988816423,
                                "height": 35.15997373045384
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_jHEl9Ot_NAkVlMk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "TORTA DI PANCARRÈ",
                                    "data": {
                                        "ingredients": "1 pacco di pancarre, 150 ml Latte, 150 g Mortadella, 150 g Edamer, 30 g Burro, 1 uovo, 1 pizzico Sale, Pangrattato",
                                        "recipe": "Se avete il pancarrè classico togliete i bordi scuri altrimenti se avete il pane da tramezzini (quello bianco lungo) tagliatelo solo a metà.\nMettete in una ciotola l’uovo, il latte e un pizzico di sale e sbattete con la forchetta o con la frusta a mano per amalgamarli bene.\nMettete ogni fetta di pancarrè nel composto di latte e uovo e fate uno strato in una teglia con carta forno.\nMettete sopra al pane uno strato di mortadella e uno strato di edamer a fette sottili poi fate un altro strato di pancarrè bagnato nel latte e uovo di nuovo uno strato di mortadella e edamer e finite con un terzo strato di pane bagnato.\nCospargete la superficie di pangrattato e mettete il burro a fiocchetti sopra.\nMettete a cuocere la torta di pancarre in forno preriscaldato ventilato a 200° per 15 minuti circa o comunque fino a che la torta sarà diventata dorata e con la crosticina croccante.\nSfornate la torta di pancarre e aspettate un paio di minuti prima di tagliarla.\nServite la torta di pancarre ben calda e filante. (fonte: blog.giallozafferano.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/GapcmvcfAb/images/Schermata_2020-09-07_alle_12.28.44.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23287445",
                            "field1": "Minestrone",
                            "field2": "Despar",
                            "field3": "15 verdure 450 g",
                            "field4": "",
                            "description": "Minestrone Despar 15 verdure 450 g",
                            "grammage": 450,
                            "price": "0.52",
                            "price_label": "€ 0,52",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 60.79984840615319,
                                "left": 72.33041754611475,
                                "width": 24.397425988816423,
                                "height": 35.15997373045385
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/verdure_pkSRa9Q.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_XZjuxC4_xoR2zuP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "ingredienti",
                                    "data": {
                                        "titolo": "Ingredienti",
                                        "testo": "Patate 20%,  Pomodori 14%, Borlotti 12%,  Carote 10%, Piselli 10%, Fagiolini 7,2%, Zucchine 7%, Sedano 6%, Bieta 4%, Porro, Verza, Zucca 2%, Prezzemolo 1%, Basilico 0,5%, Aglio 0,3%,",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/GapcmvcfAb/images/verdure.jpeg"
                                        ]
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_2_Qk1REO9.jpg",
                    "products": [
                        {
                            "item_id": "cstm01634388",
                            "field1": "trevalli",
                            "field2": "latte alta digeribilità senza lattosio",
                            "field3": "vivi digeribile/ leggero/ sano",
                            "field4": "1L",
                            "description": "trevalli latte alta digeribilità senza lattosio vivi digeribile/ leggero/ sano 1L",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "vivi digeribile",
                                "leggero",
                                "sano"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 3.2888969758374857,
                                "left": 1.2835512066831685,
                                "width": 33.84103109529703,
                                "height": 45.73681898630277
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_TpwXCij_0XloWBP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "Trevalli sito",
                                    "data": "https://www.trevalli.cooperlat.it/senza-lattosio-alta-digeribilita/"
                                }
                            ]
                        },
                        {
                            "item_id": "53196",
                            "field1": "Croissant",
                            "field2": "BAULI",
                            "field3": "classico/ 5 cereali/ senza zucchero/ integrale",
                            "field4": "200/240g",
                            "description": "Croissant BAULI classico/ 5 cereali/ senza zucchero/ integrale 200/240g",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "classico",
                                "5 cereali",
                                "senza zucchero",
                                "integrale"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 3.6727727581696006,
                                "left": 35.86836711014851,
                                "width": 20.194295698216727,
                                "height": 45.41944944980249
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/bauli_5_cereali_1463395184_1465822891.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/Bauli_Croissant_Classico_6pz_1445526505_1449221916_1457000622_146582_C9v7Yyj.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_nyRvUzk_YLGNi42.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Croissant",
                                    "data": {
                                        "titolo": "Croissant",
                                        "testo": "L’autentico sapore della tradizione diventa ancora più buono, grazie alla nuova ricetta che rende il nostro classico croissant ancora più soffice e gustoso.\nCon tutta la bontà del latte fresco, il nostro lievito madre e 20 lunghe ore di lievitazione naturale.",
                                        "img": [

                                            "https://interattivo.s3.amazonaws.com/GapcmvcfAb/images/pack.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm69441505",
                            "field1": "divella",
                            "field2": "biscotti classici/ ricchi",
                            "field3": "vari tipi da 300g a 400g",
                            "field4": "",
                            "description": "divella biscotti classici/ ricchi vari tipi da 300g a 400g",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "classici",
                                " ricchi"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 3.4829009131483115,
                                "left": 56.30906869112082,
                                "width": 19.93556348605631,
                                "height": 45.41944944980249
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_FyflvWj_AlWnStR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Biscotti Divella",
                                    "data": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/video/videoplayback.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm07482730",
                            "field1": "nastrine mulino bianco",
                            "field2": "240g",
                            "field3": "",
                            "field4": "",
                            "description": "nastrine mulino bianco 240g",
                            "grammage": null,
                            "price": "1.89",
                            "price_label": "€ 1,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 51.9518224490843,
                                "left": 0.12376237623762376,
                                "width": 23.45925510519802,
                                "height": 22.771595893397627
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_XppVChF_Clvieve.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "Nastrine Mulino Bianco",
                                    "data": "https://www.mulinobianco.it/nastrine"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99194846",
                            "field1": "corn flakes",
                            "field2": "cerealitalia 375g",
                            "field3": "",
                            "field4": "",
                            "description": "corn flakes cerealitalia 375g",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 51.7333946801416,
                                "left": 23.80830368193069,
                                "width": 20.048538056930692,
                                "height": 22.771595893397627
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_bgd8ePE_f41rdKD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm26920027",
                            "field1": "corn flakes ",
                            "field2": "kellog's 375g",
                            "field3": "",
                            "field4": "",
                            "description": "corn flakes  kellog's 375g",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 51.86164584722722,
                                "left": 44.251817759900995,
                                "width": 20.048538056930695,
                                "height": 22.771595893397627
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/k_dI5YFUW.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_3LL0wkg_0nlR4N8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "ingredienti",
                                    "data": {
                                        "titolo": "Igredienti",
                                        "testo": "Mais, Zucchero, Aroma di malto d’orzo, Sale.",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/GapcmvcfAb/images/k.jpeg"
                                        ]
                                    }
                                }
                            ],
                            "related": ["51659"]
                        },
                        {
                            "item_id": "cstm67151772",
                            "field1": "rigoni ",
                            "field2": "crema di cacao e nocciole biologica",
                            "field3": "270g",
                            "field4": "",
                            "description": "rigoni  crema di cacao e nocciole biologica 270g",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 75.10574709511107,
                                "left": 44.63229037747524,
                                "width": 21.245068842821784,
                                "height": 20.762661596470526
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_PxmRTmE_sggR8iB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm72000100", "59672"]
                        },
                        {
                            "item_id": "cstm72000100",
                            "field1": "rigoni",
                            "field2": "confettura bio gusti assortiti",
                            "field3": "250g",
                            "field4": "",
                            "description": "rigoni confettura bio gusti assortiti 250g",
                            "grammage": null,
                            "price": "2.69",
                            "price_label": "€ 2,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "mirtilli neri di bosco",
                                "ciliegie"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 53.57407947724825,
                                "left": 65.9377900680693,
                                "width": 34.06220993193069,
                                "height": 43.633952733032366
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_txq4YeA_79VB2V2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm67151772", "59672"]
                        },
                        {
                            "item_id": "cstm56517845",
                            "field1": "caffè classico",
                            "field2": "splendid",
                            "field3": "250g x2",
                            "field4": "",
                            "description": "caffè classico splendid 250g x2",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 3.6303950023125067,
                                "left": 76.6127425614489,
                                "width": 19.765006468305305,
                                "height": 43.27175596056009
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_YOKCNer_9ORD8Ot.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "50660",
                            "field1": "Caffè decaffeinato hag classico/ ",
                            "field2": "espresso 250g ",
                            "field3": "",
                            "field4": "",
                            "description": "Caffè decaffeinato hag classico/  espresso 250g ",
                            "grammage": 250,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": ['Decaffeinato', "Classico"],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 75.2282674996146,
                                "left": 3.7516170763260033,
                                "width": 19.76500646830531,
                                "height": 20.749988269912663
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/443_Hag_Classico_250_g_1501489433.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/Hag_Espresso_250g_1455868745_1472833977_1539081320.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_rTOY7Wq_lsapODW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60646098",
                            "field1": "Caffè espresso in cialde",
                            "field2": "kimbo",
                            "field3": "napotano x18 126g",
                            "field4": "",
                            "description": "Caffè espresso in cialde kimbo napotano x18 126g",
                            "grammage": null,
                            "price": "2.39",
                            "price_label": "€ 2,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 74.69203493555158,
                                "left": 23.54463130659767,
                                "width": 20.541203104786547,
                                "height": 21.286220833975694
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_pB6gkv4_jdLpPZv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Kimbo Napoletano",
                                    "data": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/video/Kimbo-_il-talento-napoletano-nelle-nuove-capsule.mp4"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_3_gdCrddJ.jpg",
                    "products": [
                        {
                            "item_id": "cstm28976495",
                            "field1": "bebè",
                            "field2": "omogeneizzati biologici",
                            "field3": "mela",
                            "field4": "",
                            "description": "bebè omogeneizzati biologici mela",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.543770520186735,
                                "left": 4.368908570544554,
                                "width": 20.53536896658416,
                                "height": 34.29516364848919
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_V5rc1m9_59wJTCK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "51725",
                            "field1": "Wafer",
                            "field2": "despar",
                            "field3": "cacao/ nocciola/ vaniglia",
                            "field4": "175g",
                            "description": "Wafer despar cacao/ nocciola/ vaniglia 175g",
                            "grammage": 175,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "cacao",
                                "nocciola",
                                "vaniglia"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 10.247148014671936,
                                "left": 23.932549504950497,
                                "width": 20.53536896658416,
                                "height": 34.29516364848919
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1006086_8000380007264_Loacker_Cremkakao_175_g_23102015_1015_1465206007.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1006583_8000380007271_Loacker_Milk_175_g_23102015_1015_1465206014.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_PcQP2A8_kL3ECxE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "51794",
                            "field1": "capsule",
                            "field2": "premium",
                            "field3": "vari tipi",
                            "field4": "50g",
                            "description": "capsule premium vari tipi 50g",
                            "grammage": 50,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "aida",
                                "elisir d'amore",
                                "tosca"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 5.463780267275434,
                                "left": 41.63056930693069,
                                "width": 22.09400139232673,
                                "height": 39.87158451110656
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1097651_CAPSULE_PREMIUM_50G_TOSCA_1458053267.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1097650_CAPSULE_PREMIUM_50G_ELISIR_DAMORE_1458053283.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1097652_CAPSULE_PREMIUM_50G_AIDA_1458053292.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_E1BxBHJ_NrN1XFF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "63622",
                            "field1": "tavolette di cioccolato",
                            "field2": "duca degli abruzzi",
                            "field3": "vari gusti",
                            "field4": "da 50g a 75g",
                            "description": "tavolette di cioccolato duca degli abruzzi vari gusti da 50g a 75g",
                            "grammage": null,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "latte",
                                "fondente"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 3.6211717026624957,
                                "left": 65.51235689975246,
                                "width": 30.31694771039604,
                                "height": 42.816852523982966
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1098953_TAVOLETTA_CIOCCOLATO_DUCA_LAT_G75_1516092344.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1098960_TAVOLETTA_CIOCCOLATO_DUCA_fond_G75_1516092344.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_QLVlfVF_4LRZDy0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Brownie alle castagne servito con panna montata",
                                    "data": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/video/Brownie_alle_castagne_servito_con_panna_montata.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84584983",
                            "field1": "kinder ferrero",
                            "field2": "colazione più x10 integrali",
                            "field3": "280g",
                            "field4": "",
                            "description": "kinder ferrero colazione più x10 integrali 280g",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 54.48987296721901,
                                "left": 4.707804764851486,
                                "width": 30.31694771039604,
                                "height": 42.81685252398297
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_V7Pe5xs_9TnrGCj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm34659860",
                            "field1": "balconi",
                            "field2": "choco e latte 300g",
                            "field3": "snack al latte 280g",
                            "field4": "",
                            "description": "balconi choco e latte 300g snack al latte 280g",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "choco e latte",
                                "snack al latte"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 54.48987296721901,
                                "left": 35.024752475247524,
                                "width": 20.599667388613863,
                                "height": 20.244647116913765
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_8FCPje5_LE0bAU3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "51729",
                            "field1": "cereali nesquik",
                            "field2": "nestlè",
                            "field3": "375g",
                            "field4": "",
                            "description": "cereali nesquik nestlè 375g",
                            "grammage": 375,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 52.27152856153491,
                                "left": 55.59686339727723,
                                "width": 20.599667388613863,
                                "height": 22.177933264505207
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/Nesquik_cereali_375gr_1525271461_1527150796_1542631675_1564569120.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_3Z7Lt2M_Y5sDgxb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["51659"]
                        },
                        {
                            "item_id": "cstm64910851",
                            "field1": "ferrero nutella b-ready",
                            "field2": "x6 132g",
                            "field3": "",
                            "field4": "",
                            "description": "ferrero nutella b-ready x6 132g",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 75.17137562201815,
                                "left": 35.30418471534654,
                                "width": 20.599667388613863,
                                "height": 22.177933264505207
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_7pUGxtK_wdikB51.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49876940",
                            "field1": "kinder cards pz5",
                            "field2": "128g",
                            "field3": "",
                            "field4": "",
                            "description": "kinder cards pz5 128g",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 75.1383108680039,
                                "left": 55.5552869740099,
                                "width": 20.599667388613863,
                                "height": 22.177933264505207
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_m5XU9uH_Zdty6Ai.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm69209089",
                            "field1": "nestlè",
                            "field2": "latte mio brick",
                            "field3": "500ml",
                            "field4": "",
                            "description": "nestlè latte mio brick 500ml",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 53.19333382496279,
                                "left": 76.73267326732673,
                                "width": 20.599667388613863,
                                "height": 43.96610321653927
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_eRFFc35_i3aJuKd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 4,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_4_4hG5Vov.jpg",
                    "products": [
                        {
                            "item_id": "62502",
                            "field1": "legumi",
                            "field2": "despar",
                            "field3": "ceci/ fagioli cannellini/ fagioli borlotti",
                            "field4": "340g",
                            "description": "legumi despar ceci/ fagioli cannellini/ fagioli borlotti 340g",
                            "grammage": 340,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "ceci",
                                "fagioli cannellini",
                                "fagioli borlotti"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 4.3917608243984905,
                                "left": 3.0848739170792077,
                                "width": 31.064356435643568,
                                "height": 42.954121351254294
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1055008_ceci_DESPAR_340g_8001300240181_1470133442.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1055009_borlotti_DESPAR_340g_8001300240167_1470133450.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_pe7LTtD_mtmZSEF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "53052",
                            "field1": "Tonno all'olio d'oliva",
                            "field2": "mare aperto",
                            "field3": "80g x3",
                            "field4": "",
                            "description": "Tonno all'olio d'oliva mare aperto 80g x3",
                            "grammage": 240,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 4.581632669419781,
                                "left": 35.08856745049505,
                                "width": 20.93856358292079,
                                "height": 42.574377661211706
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_WINMdcf_5B5ofIy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "81150",
                            "field1": "PASSATA DI POMODORO ",
                            "field2": "GRANORO",
                            "field3": "690G",
                            "field4": "",
                            "description": "PASSATA DI POMODORO  GRANORO 690G",
                            "grammage": 690,
                            "price": "0.55",
                            "price_label": "€ 0,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 5.72637453188323,
                                "left": 56.319023442002994,
                                "width": 20.033000840359342,
                                "height": 42.574377661211706
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_zq7D2nM_FHs1G13.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Orecchiette al forno",
                                    "data": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/video/Orecchiette_al_forno.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49561862",
                            "field1": "gallo",
                            "field2": "riso arborio",
                            "field3": "1kg",
                            "field4": "",
                            "description": "gallo riso arborio 1kg",
                            "grammage": null,
                            "price": "2.19",
                            "price_label": "€ 2,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 5.156758996819359,
                                "left": 75.76481280940594,
                                "width": 20.938563582920793,
                                "height": 42.57437766121171
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_SDeeqGR_cyEjJYC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm85756829",
                            "field1": "rio mare",
                            "field2": "tonno al naturale",
                            "field3": "80g X3 + 1",
                            "field4": "",
                            "description": "rio mare tonno al naturale 80g X3 + 1",
                            "grammage": null,
                            "price": "3.39",
                            "price_label": "€ 3,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 54.851581336890156,
                                "left": 0.0,
                                "width": 23.597520884900995,
                                "height": 20.08383217693531
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_Tef69hh_IyQmay9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60464362",
                            "field1": "barilla",
                            "field2": "pesto gusti assortiti",
                            "field3": "190/200g",
                            "field4": "",
                            "description": "barilla pesto gusti assortiti 190/200g",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 54.466827835633296,
                                "left": 24.211498298267326,
                                "width": 20.141359839108915,
                                "height": 20.21208334402093
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_gUsyHCX_r5Ufy55.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm37802507",
                            "field1": "barilla",
                            "field2": "farina 00",
                            "field3": "1kg",
                            "field4": "",
                            "description": "barilla farina 00 1kg",
                            "grammage": null,
                            "price": "0.55",
                            "price_label": "€ 0,55",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 54.376651233776215,
                                "left": 44.449064047029694,
                                "width": 20.141359839108915,
                                "height": 20.21208334402093
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_XPVCyuZ_5kDwbpO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm02719232",
                            "field1": "alisa",
                            "field2": "olive verdi denocciolate 340g/",
                            "field3": "olive nere intere 425g/",
                            "field4": "olive nere denocciolate 340g",
                            "description": "alisa olive verdi denocciolate 340g/ olive nere intere 425g/ olive nere denocciolate 340g",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 75.56664972682499,
                                "left": 3.2221728032178145,
                                "width": 20.141359839108915,
                                "height": 20.21208334402093
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_jX9kmFr_YrfDpvU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm92734474",
                            "field1": "ponti glassa",
                            "field2": "vari tipi da 220g a 250g",
                            "field3": "",
                            "field4": "",
                            "description": "ponti glassa vari tipi da 220g a 250g",
                            "grammage": null,
                            "price": "2.19",
                            "price_label": "€ 2,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 75.47146331375365,
                                "left": 23.028504022277218,
                                "width": 20.141359839108915,
                                "height": 20.21208334402093
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_Z6sd82D_sTqUWpK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm73946108",
                            "field1": "galbusera",
                            "field2": "riso su riso crackers integrali",
                            "field3": "380g",
                            "field4": "",
                            "description": "galbusera riso su riso crackers integrali 380g",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 75.59971448083927,
                                "left": 44.48048808787127,
                                "width": 20.141359839108915,
                                "height": 20.21208334402093
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_fiUogNJ_vP3vyqJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "53243",
                            "field1": "Salse Top Down",
                            "field2": "calvè",
                            "field3": "ketchup/ maionese vari gusti",
                            "field4": "225/250ml",
                            "description": "Salse Top Down calvè ketchup/ maionese vari gusti 225/250ml",
                            "grammage": 0,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "ketchup",
                                "maionese"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 53.179807334684234,
                                "left": 65.90491568688118,
                                "width": 32.33872215346535,
                                "height": 42.85542807033294
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1030226_ketch_CALVE_top_g250_1459785421.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1030253_ketc_CALVE_top_hot_g250_1459785440.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/Calve_maionese_top_down_classica_1479985498.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_GyBKBUN_382Xn1r.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 5,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_5_35jh76m.jpg",
                    "products": [
                        {
                            "item_id": "54539",
                            "field1": "Pan bauletto",
                            "field2": "despar",
                            "field3": "bianco/ grano duro",
                            "field4": "400g",
                            "description": "Pan bauletto despar bianco/ grano duro 400g",
                            "grammage": 400,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Grano duro"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 7.087961062945674,
                                "left": 4.359723081683168,
                                "width": 28.39186262376238,
                                "height": 38.251912545529166
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_YEFLWVl_Viz0mB7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm64759265", "51841", "cstm38057346", "cstm70970775", "55316", "54671", "cstm29325996", "cstm03331103",]
                        },
                        {
                            "item_id": "58276",
                            "field1": "CRACKERS",
                            "field2": "DESPAR",
                            "field3": "SALATI/ NON SALATI",
                            "field4": "500G",
                            "description": "CRACKERS DESPAR SALATI/ NON SALATI 500G",
                            "grammage": 500,
                            "price": "1.15",
                            "price_label": "€ 1,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "salati",
                                "non salati"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 6.327972701739086,
                                "left": 34.52100092821782,
                                "width": 28.39186262376238,
                                "height": 38.251912545529166
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_Y2cmjYp_y1oSgsr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "59672",
                            "field1": "fette biscottate\t\t\t",
                            "field2": "grissin bon",
                            "field3": "vari tipi",
                            "field4": "250g",
                            "description": "fette biscottate\t\t\t grissin bon vari tipi 250g",
                            "grammage": 250,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classiche",
                                "Cereali",
                                "Integrali"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 4.646680058226031,
                                "left": 66.03012840346535,
                                "width": 29.61594987623763,
                                "height": 42.94510369106859
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/120HA-310_ZtFkP7d.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/125HA-310_WEV0m5y.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/130HA-310_eZY8aOB.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_1HPIGOL_ZNmS6Gb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["cstm72000100", "cstm67151772"]
                        },
                        {
                            "item_id": "84650",
                            "field1": "SIMMENTHAL",
                            "field2": "CLASSICA",
                            "field3": "3x70gr",
                            "field4": "",
                            "description": "SIMMENTHAL CLASSICA 3x70gr",
                            "grammage": 210,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 78.12007034576514,
                                "left": 6.839805074257426,
                                "width": 45.933729115099005,
                                "height": 15.366092956445904
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/SIMMENTHAL_120G_1487236577_1487671758.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_jLGPRhl_8qV9thH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm21382687",
                            "field1": "crik crok",
                            "field2": "patatine più croccanti",
                            "field3": "180g",
                            "field4": "",
                            "description": "crik crok patatine più croccanti 180g",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 50.21792678782127,
                                "left": 55.03316444925742,
                                "width": 21.301148669554458,
                                "height": 24.187368542553738
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_Ol73SLC_mTiN4jb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm24907996",
                            "field1": "pringles",
                            "field2": "vari gusti 165/175g",
                            "field3": "",
                            "field4": "",
                            "description": "pringles vari gusti 165/175g",
                            "grammage": null,
                            "price": "1.89",
                            "price_label": "€ 1,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "paprika",
                                "original"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 75.81263145744627,
                                "left": 54.75808323019801,
                                "width": 21.301148669554458,
                                "height": 24.187368542553738
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_1B0q2Ya_MCC6FCL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm53643953",
                            "field1": "felix cibo per gatto",
                            "field2": "gusti assortiti 100g x 4",
                            "field3": "le ghiottonerie/ sensations ",
                            "field4": "",
                            "description": "felix cibo per gatto gusti assortiti 100g x 4 le ghiottonerie/ sensations ",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "le ghiottonerie",
                                "sensations "
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 51.7154395167496,
                                "left": 76.61326191212872,
                                "width": 21.301148669554458,
                                "height": 24.187368542553738
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_3ik623G_AtvBA90.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42275058",
                            "field1": "friskies cibo per gatti",
                            "field2": "adult vari tipi",
                            "field3": "2kg",
                            "field4": "",
                            "description": "friskies cibo per gatti adult vari tipi 2kg",
                            "grammage": null,
                            "price": "4.49",
                            "price_label": "€ 4,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 74.95745668316832,
                                "left": 76.92073406559406,
                                "width": 21.301148669554458,
                                "height": 24.187368542553738
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_KpncIgE_lVF0DAM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 6,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_6_H1L5QMF.jpg",
                    "products": [
                        {
                            "item_id": "cstm87107487",
                            "field1": "fruttolo magie di frutta",
                            "field2": "yogurt gusto fragola ",
                            "field3": "340g",
                            "field4": "",
                            "description": "fruttolo magie di frutta yogurt gusto fragola  340g",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 3.816970420071188,
                                "left": 3.6222509702457955,
                                "width": 30.78913324708926,
                                "height": 46.116000509420935
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/fruttolo_8cYsB6m.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_xb4Z8bd_ku3NhVg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Fruttolo",
                                    "data": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/video/Fruttolo-Spot.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "124629",
                            "field1": "6 mini budini",
                            "field2": "Cameo muu muu ",
                            "field3": "latte nocciola/ cioccolato/ vaniglia",
                            "field4": "300g",
                            "description": "6 mini budini Cameo muu muu  latte nocciola/ cioccolato/ vaniglia 300g",
                            "grammage": 300,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 3.548854138039671,
                                "left": 35.963777490297545,
                                "width": 30.78913324708926,
                                "height": 46.116000509420935
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/muu-muu-mini-cioccolatopng_1514967225.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/muu-muu-mini-vanigliapng_1514967225.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_iA8eYAr_M4HWCSK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm95456085",
                            "field1": "yogurt parmalat",
                            "field2": "goloso/intero/0.1%",
                            "field3": "gusti assortiti 125g x2",
                            "field4": "",
                            "description": "yogurt parmalat goloso/intero/0.1% gusti assortiti 125g x2",
                            "grammage": null,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 3.548854138039671,
                                "left": 67.01164294954722,
                                "width": 29.236739974126777,
                                "height": 46.116000509420935
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/parmalat_4mDJxLG.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_RRDdm3O_2NQ2wLe.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm65027301",
                            "field1": "fior di latte",
                            "field2": "galbanino",
                            "field3": "200g",
                            "field4": "",
                            "description": "fior di latte galbanino 200g",
                            "grammage": null,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 50.871377916602434,
                                "left": 3.492884864165588,
                                "width": 20.181112548512292,
                                "height": 23.99640724182077
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/galbanfiordifetteg200_SUJCdT2.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_9FOOdJ4_x30DN1Y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm66199238",
                            "field1": "mini lingotto ",
                            "field2": "perugina",
                            "field3": "6 x 20g fiordilatte/cioccolato",
                            "field4": "",
                            "description": "mini lingotto  perugina 6 x 20g fiordilatte/cioccolato",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 51.00543605761819,
                                "left": 23.673997412677878,
                                "width": 20.181112548512292,
                                "height": 23.99640724182077
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/PERUGINA-LINGOTTO-F.DI-LATTE-GR30X4_8d5997ace57b90f_vnOAXW5.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_8tT3g8Y_nGzIq7B.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm58937268",
                            "field1": "lci vital",
                            "field2": "nestlè",
                            "field3": "vari gusti 90g x8",
                            "field4": "",
                            "description": "lci vital nestlè vari gusti 90g x8",
                            "grammage": null,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 75.13590144045473,
                                "left": 1.9404915912031049,
                                "width": 42.432082794307895,
                                "height": 20.644953716426805
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/lci_3dlgrzU.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_YTlGflZ_gnQzB7f.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "125265",
                            "field1": "philadelphia",
                            "field2": "light/active/senza lattosio/ yogurt alla greca",
                            "field3": "175g",
                            "field4": "",
                            "description": "philadelphia light/active/senza lattosio/ yogurt alla greca 175g",
                            "grammage": 175,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 53.954715159964884,
                                "left": 44.76067270375161,
                                "width": 51.61707632600258,
                                "height": 42.362372560979686
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/Philadelphia_light_1521712110.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_sJeXFYo_6mnWYjx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 7,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_7_fdCsJbr.jpg",
                    "products": [
                        {
                            "item_id": "cstm94294448",
                            "field1": "mozzarella",
                            "field2": "despar",
                            "field3": "100g",
                            "field4": "",
                            "description": "mozzarella despar 100g",
                            "grammage": null,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 8.054313655832537,
                                "left": 4.685187580853816,
                                "width": 20.28247089262613,
                                "height": 38.44566288399278
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/mozz_A33d49m.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_SlguPGu_bLCzErA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm74203029",
                            "field1": "yogurt greco bianco 0%/2%",
                            "field2": "despar vari gusti",
                            "field3": "150g",
                            "field4": "",
                            "description": "yogurt greco bianco 0%/2% despar vari gusti 150g",
                            "grammage": null,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 7.9202555148167795,
                                "left": 25.642496765847344,
                                "width": 20.28247089262613,
                                "height": 38.44566288399278
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/yogurt_rEU2Ksa.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_zZwnUTA_0XHmEzs.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60214087",
                            "field1": "tacchino arrosto affettato",
                            "field2": "despar",
                            "field3": "140g",
                            "field4": "",
                            "description": "tacchino arrosto affettato despar 140g",
                            "grammage": null,
                            "price": "2.59",
                            "price_label": "€ 2,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 7.78619737380102,
                                "left": 44.918046571798186,
                                "width": 18.859443725743855,
                                "height": 38.44566288399278
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/tacchino_naneJxz.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_yEW8EBV_oJ8s536.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm33021492",
                            "field1": "grana padano dop",
                            "field2": "grattugiato",
                            "field3": "latteria soresina 100g",
                            "field4": "",
                            "description": "grana padano dop grattugiato latteria soresina 100g",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 5.291609971244531,
                                "left": 66.36481241914618,
                                "width": 30.27166882276843,
                                "height": 42.49643070199546
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/gran_iZ2xnAJ.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_klGcLGe_WxkOHMW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm15675025",
                            "field1": "pasta ripiena rana",
                            "field2": "sfogliavelo/duetto",
                            "field3": "vari tipi 250g",
                            "field4": "",
                            "description": "pasta ripiena rana sfogliavelo/duetto vari tipi 250g",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 54.62500586504367,
                                "left": 4.010349288486417,
                                "width": 29.883570504527814,
                                "height": 41.69208185590091
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/prosciutto_crudo_PDoDzzp.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_aL1Z1ZJ_QiR5jgy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm86926692",
                            "field1": "robiola",
                            "field2": "nonno nanni ",
                            "field3": "100g",
                            "field4": "",
                            "description": "robiola nonno nanni  100g",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 53.284424454886086,
                                "left": 34.92884864165588,
                                "width": 20.95730918499353,
                                "height": 21.71741884455288
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/robiola_G6pfpsp.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_l4Q4mN5_Aqd4q7x.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "54513",
                            "field1": "fiocchi di latte",
                            "field2": "jocca 175g",
                            "field3": "senza lattosio 150g",
                            "field4": "",
                            "description": "fiocchi di latte jocca 175g senza lattosio 150g",
                            "grammage": 175,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 53.15036631387033,
                                "left": 55.88615782664941,
                                "width": 20.310478654592494,
                                "height": 21.71741884455288
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/Jocca_gr_175_1455893594_1482146528_1488381366.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_lr6SdvR_0l3u1Ch.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88159151",
                            "field1": "mini baby bel",
                            "field2": "rosso",
                            "field3": "x5 100g",
                            "field4": "",
                            "description": "mini baby bel rosso x5 100g",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 53.15036631387033,
                                "left": 76.58473479948253,
                                "width": 20.310478654592494,
                                "height": 21.71741884455288
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/babybel_DIVfZzV.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_bJDB1cc_9oodfLn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23188513",
                            "field1": "pasta brisée",
                            "field2": "sfoglia buitoni",
                            "field3": "230g",
                            "field4": "",
                            "description": "pasta brisée sfoglia buitoni 230g",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 75.13590144045473,
                                "left": 34.67011642949548,
                                "width": 20.310478654592494,
                                "height": 20.913069998458333
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/pasta_RlcSrit.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_hwxEad6_1F7OUxV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60540282",
                            "field1": "l'abc della merenda",
                            "field2": "con plumcake",
                            "field3": "parmareggio",
                            "field4": "",
                            "description": "l'abc della merenda con plumcake parmareggio",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 75.00184329943897,
                                "left": 55.75679172056921,
                                "width": 20.310478654592494,
                                "height": 20.913069998458333
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/abc_t0Tpn2A.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_KNKnBbM_euQiqt4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm26451484",
                            "field1": "pesto/ sughi freschi",
                            "field2": "rana",
                            "field3": "vari tipi",
                            "field4": "",
                            "description": "pesto/ sughi freschi rana vari tipi",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 74.86778515842322,
                                "left": 76.58473479948253,
                                "width": 20.310478654592494,
                                "height": 20.913069998458333
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/pesto-fresco-giovanni-rana-pistacchio-noci-mediterranea_eg1RlqI.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_m8LgSl3_mHNtJFj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 8,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_8_PoWaQGd.jpg",
                    "products": [
                        {
                            "item_id": "cstm64759265",
                            "field1": "prosciutto crudo",
                            "field2": "nazionale",
                            "field3": "",
                            "field4": "",
                            "description": "prosciutto crudo nazionale",
                            "grammage": null,
                            "price": "1.75",
                            "price_label": "€ 1,75 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 3.764453143328265,
                                "left": 3.4422056921086672,
                                "width": 61.93835705045279,
                                "height": 36.97102333281945
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/prosciutto_HM2gQSZ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_z60lGgs_wTsFTFB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["54539", "51841", "cstm38057346", "cstm70970775", "55316", "54671", "cstm29325996", "cstm03331103",]
                        },
                        {
                            "item_id": "51841",
                            "field1": "Prosciutto cotto fetta golosa",
                            "field2": "GALBANI",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "Prosciutto cotto fetta golosa GALBANI all'etto",
                            "grammage": 100,
                            "price": "1.29",
                            "price_label": "€ 1,29 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 37.2789883972679,
                                "left": 3.0541073738680464,
                                "width": 61.93835705045279,
                                "height": 34.55797679453579
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/piatto_prossciutto_cotto_1454685165.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/1040213_Galbani_Galbacotto_Fetta_golosa_large_1533823366.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/Prosciutto_Cotto_sisa_1436979215_1497426007_1533823367.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_xe6nASt_GGrlAyz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["54539", "cstm64759265", "cstm38057346", "cstm70970775", "55316", "54671", "cstm29325996", "cstm03331103",]
                        },
                        {
                            "item_id": "cstm38057346",
                            "field1": "salame ",
                            "field2": "golfera golfetta",
                            "field3": "",
                            "field4": "",
                            "description": "salame  golfera golfetta",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 5.507208976533126,
                                "left": 65.74598965071151,
                                "width": 34.254010349288485,
                                "height": 24.77173250038542
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/download_ubYAhRw.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_xF3hlg0_6q2jye4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["54539", "cstm64759265", "51841", "cstm70970775", "55316", "54671", "cstm29325996", "cstm03331103",]
                        },
                        {
                            "item_id": "cstm70970775",
                            "field1": "mortadella",
                            "field2": "favola in",
                            "field3": "cotenna",
                            "field4": "",
                            "description": "mortadella favola in cotenna",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 30.576081346479974,
                                "left": 65.74598965071151,
                                "width": 34.254010349288485,
                                "height": 21.68839525702297
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/mortadella_HrULDYZ.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_IN825zU_bmMIYiN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["54539", "cstm64759265", "51841", "cstm38057346", "55316", "54671", "cstm29325996", "cstm03331103",]
                        },
                        {
                            "item_id": "55316",
                            "field1": "Speck",
                            "field2": "MERANO",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "Speck MERANO all'etto",
                            "grammage": 100,
                            "price": "1.29",
                            "price_label": "€ 1,29 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 52.42755833204861,
                                "left": 65.74598965071151,
                                "width": 34.254010349288485,
                                "height": 21.68839525702297
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/Speck_tagliere_ambientato_ok_1524555269_1527243736.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_i2INTzl_aW2b8sp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["54539", "cstm64759265", "51841", "cstm38057346", "cstm70970775", "54671", "cstm29325996", "cstm03331103",]
                        },
                        {
                            "item_id": "54671",
                            "field1": "carpaccio",
                            "field2": "di bresaola",
                            "field3": "all'etto",
                            "field4": "",
                            "description": "carpaccio di bresaola all'etto",
                            "grammage": 100,
                            "price": "2.39",
                            "price_label": "€ 2,39 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 74.41309345863301,
                                "left": 65.74598965071151,
                                "width": 34.254010349288485,
                                "height": 21.68839525702297
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/carpaccio_di_manzo_Piatto_1484815276.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/carpaccio_bresaola_1487693135_150460367115_1552579255.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_FU2Hy5e_5Jv4te8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["54539", "cstm64759265", "51841", "cstm38057346", "cstm70970775", "55316", "cstm29325996", "cstm03331103",]
                        },
                        {
                            "item_id": "cstm29325996",
                            "field1": "pancetta coppata campagnola",
                            "field2": "furlotti",
                            "field3": "",
                            "field4": "",
                            "description": "pancetta coppata campagnola furlotti",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 74.01091903558574,
                                "left": 34.56875808538163,
                                "width": 31.019857697283314,
                                "height": 22.090569680070246
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/PANCETTA-CAMPAGNOLA-CON-COTENNA1-0-kg-extra-big-306-971_sI9dcto.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_HsUhyVp_1c65tS6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["54539", "cstm64759265", "51841", "cstm38057346", "cstm70970775", "55316", "54671", "cstm03331103",]
                        },
                        {
                            "item_id": "cstm03331103",
                            "field1": "salame galbanetto",
                            "field2": "galbani",
                            "field3": "",
                            "field4": "",
                            "description": "salame galbanetto galbani",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 74.1449771766015,
                                "left": 3.3915265200517455,
                                "width": 31.019857697283314,
                                "height": 21.822453398038732
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/galbanetto_5IEjFIQ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_3QUL7Od_YSljKYC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "related": ["54539", "cstm64759265", "51841", "cstm38057346", "cstm70970775", "55316", "54671", "cstm29325996", "cstm03331103",]
                        }
                    ]
                },
                {
                    "number": 9,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_9_MXQL10O.jpg",
                    "products": [
                        {
                            "item_id": "cstm68506010",
                            "field1": "leerdammer",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "leerdammer",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 5.373150835517367,
                                "left": 3.0541073738680464,
                                "width": 30.890491591203105,
                                "height": 25.1739069234327
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/leerdammer_ppDuFOh.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_0PFaq93_7UxC1I5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Hamburger piccante con Leerdammer e Peperoncino",
                                    "data": {
                                        "ingredients": "200g di Carne trita di manzo, 50g di Pane bianco, 5cl di Latte, 1 Uovo, 2 fette di Leerdammer Special Toast, 1/2 Spicchio d'aglio, 1/2 Peperoncino, Coriandolo e cumino, Sale, Olio EVO, 2 Panini al latte grandi, Lattuga, 1/2 Pomodoro, 1/2 Cetriolo, Salsa piccante",
                                        "recipe": "1) Ammollare il pane nel latte.\n2) Mescolare la carne con il pane ammollato, l’uovo, lo spicchio d’aglio tritato, il peperoncino, i semi di cumino e coriandolo tritati e un pizzico di sale.\n3) Cuocere gli hamburger da ambo i lati per alcuni minuti.\n4) Servirli ben caldi nel pane con le fette di Special Toast e una guarnizione di lattuga, pomodori, cetrioli e salsa piccante.",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/GapcmvcfAb/images/hamburger-piccante-con-special-toast-1.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm28145981",
                            "field1": "formaggio bel paese",
                            "field2": "galbani",
                            "field3": "",
                            "field4": "",
                            "description": "formaggio bel paese galbani",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 30.576081346479974,
                                "left": 3.3128395860284603,
                                "width": 30.890491591203105,
                                "height": 21.554337116007215
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/belpaese_DbKJuxc.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_ufIhU4x_2wIgGPv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm50391929",
                            "field1": "provolone ",
                            "field2": "cademartori",
                            "field3": "",
                            "field4": "",
                            "description": "provolone  cademartori",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 52.29350019103285,
                                "left": 3.183473479948254,
                                "width": 30.890491591203105,
                                "height": 21.554337116007215
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/provolone_eA2yMTn.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_BZnZsss_ucnivrj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm30415204",
                            "field1": "formaggio pecorino brigante",
                            "field2": "pinna",
                            "field3": "classica/peperoncino",
                            "field4": "",
                            "description": "formaggio pecorino brigante pinna classica/peperoncino",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 74.1449771766015,
                                "left": 3.0541073738680464,
                                "width": 30.890491591203105,
                                "height": 21.956511539054492
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/formaggio_6obcXUf.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_8Bl7LSd_YxmT7gE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm86757893",
                            "field1": "cacio fiaschetto",
                            "field2": "il priore",
                            "field3": "bianco/affumicato",
                            "field4": "",
                            "description": "cacio fiaschetto il priore bianco/affumicato",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 74.1449771766015,
                                "left": 34.619437257438555,
                                "width": 30.890491591203105,
                                "height": 21.956511539054492
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/priore_6cz1sbh.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_4ThG4yo_tGvxQWB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm34035953",
                            "field1": "treccione affumicato",
                            "field2": "zappalà",
                            "field3": "",
                            "field4": "",
                            "description": "treccione affumicato zappalà",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 74.27903531761726,
                                "left": 65.66730271668823,
                                "width": 30.890491591203105,
                                "height": 21.822453398038732
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/Treccione-affumicato-Zappala_8d1d2d30f0433e5_LUnsnVb.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_Gw2Xud2_6iP4GDv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm85222364",
                            "field1": "scamorza saporì",
                            "field2": "bianca/affumicata",
                            "field3": "400g",
                            "field4": "",
                            "description": "scamorza saporì bianca/affumicata 400g",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 43.98189544805582,
                                "left": 34.74880336351876,
                                "width": 61.93835705045279,
                                "height": 28.123186025779386
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/scamorza_hQB7Bx8.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_L3vKneK_cbwh2eg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm36868204",
                            "field1": "pecorino",
                            "field2": "romano dop",
                            "field3": "",
                            "field4": "",
                            "description": "pecorino romano dop",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 3.4963368612967476,
                                "left": 34.87816946959896,
                                "width": 61.93835705045279,
                                "height": 38.7137791660243
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/12-pecorino-romano_001_1jvlAAq.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_zqMalsl_Yx5J27X.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 10,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_10_q9aVja0.jpg",
                    "products": [
                        {
                            "item_id": "61021",
                            "field1": "Pollo alla cacciatora",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Pollo alla cacciatora al kg",
                            "grammage": null,
                            "price": "3.90",
                            "price_label": "€ 3,90 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 3.3622787202809885,
                                "left": 3.571571798188874,
                                "width": 30.631759379042695,
                                "height": 67.8043957664439
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/pollo_alla_cacciatora_despar_1470043367_1499763268_1536575709.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_qyYpo8T_pcaqV51.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "51848",
                            "field1": "coscette",
                            "field2": "di pollo",
                            "field3": "al kg",
                            "field4": "",
                            "description": "coscette di pollo al kg",
                            "grammage": null,
                            "price": "2.59",
                            "price_label": "€ 2,59 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 3.3622787202809885,
                                "left": 36.042464424320826,
                                "width": 28.173803363518758,
                                "height": 67.8043957664439
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/5031304_1552558462.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_OUhAHab_WOvCyW3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Ricetta despar",
                                    "data": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/video/10000000_335780637617977_8649137664835397569_n.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm97472349",
                            "field1": "Reale a fette ",
                            "field2": "di bovino adulto",
                            "field3": "",
                            "field4": "",
                            "description": "Reale a fette  di bovino adulto",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 3.764453143328264,
                                "left": 65.92603492884864,
                                "width": 30.631759379042695,
                                "height": 28.391302307810896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/reale_FhuDNhe.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_KKi7t6L_NhzgPk2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm45594423",
                            "field1": "Salsiccia fresca",
                            "field2": "di suino",
                            "field3": "",
                            "field4": "",
                            "description": "Salsiccia fresca di suino",
                            "grammage": null,
                            "price": "5.49",
                            "price_label": "€ 5,49 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 31.916662756637557,
                                "left": 66.31413324708927,
                                "width": 30.631759379042695,
                                "height": 23.967383654290867
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/salsiccia_MiwCN55.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_uc4cLAw_iHLB0SO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm21794462",
                            "field1": "Coppa con osso",
                            "field2": "di suino",
                            "field3": "",
                            "field4": "",
                            "description": "Coppa con osso di suino",
                            "grammage": null,
                            "price": "5.29",
                            "price_label": "€ 5,29 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 55.64495371642681,
                                "left": 66.18476714100906,
                                "width": 30.631759379042695,
                                "height": 21.152162692959937
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/coppa_EsWFmnK.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_D9xsHRE_Xndvlws.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm44127925",
                            "field1": "bocconcini",
                            "field2": "di tacchino",
                            "field3": "",
                            "field4": "",
                            "description": "bocconcini di tacchino",
                            "grammage": null,
                            "price": "5.90",
                            "price_label": "€ 5,90 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 76.55802371488515,
                                "left": 66.05540103492885,
                                "width": 30.631759379042695,
                                "height": 19.275348718739316
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/tac_SITrGb5.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_e9xvdQn_w5cDLpc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm32703346",
                            "field1": "spinacine aia",
                            "field2": "x2 220g",
                            "field3": "",
                            "field4": "",
                            "description": "spinacine aia x2 220g",
                            "grammage": null,
                            "price": "1.35",
                            "price_label": "€ 1,35",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 74.54715159964879,
                                "left": 4.0890362225097014,
                                "width": 20.541203104786547,
                                "height": 21.152162692959937
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/s_bx6WVDJ.jpeg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_DWgtKSE_UIed2q9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm02965763",
                            "field1": "hamburger classico",
                            "field2": "di tacchino",
                            "field3": "amadori 204g",
                            "field4": "",
                            "description": "hamburger classico di tacchino amadori 204g",
                            "grammage": null,
                            "price": "1.50",
                            "price_label": "€ 1,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 74.68120974066454,
                                "left": 24.528880983182404,
                                "width": 20.541203104786547,
                                "height": 21.152162692959937
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/t_9HXT9tX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_0GOOxO5_MolskgJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm00825342",
                            "field1": "salsicce con pollo e tacchino ",
                            "field2": "amadori 430g",
                            "field3": "",
                            "field4": "",
                            "description": "salsicce con pollo e tacchino  amadori 430g",
                            "grammage": null,
                            "price": "2.90",
                            "price_label": "€ 2,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 74.68120974066454,
                                "left": 44.96872574385511,
                                "width": 20.541203104786547,
                                "height": 21.152162692959937
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/sss_3Kj6p7M.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/products/cropped_image_KKsBDeV_oMsjITA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 11,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_11_39x09FE.jpg",
                    "products": []
                },
                {
                    "number": 12,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_12_K97QETH.jpg",
                    "products": []
                },
                {
                    "number": 13,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_13_xyIJIp1.jpg",
                    "products": []
                },
                {
                    "number": 14,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_14_YkTyCrU.jpg",
                    "products": []
                },
                {
                    "number": 15,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_15_rrSuffS.jpg",
                    "products": []
                },
                {
                    "number": 16,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_16_HCjQpl3.jpg",
                    "products": []
                },
                {
                    "number": 17,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_17_jqvrsVd.jpg",
                    "products": []
                },
                {
                    "number": 18,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_18_qBRERZj.jpg",
                    "products": []
                },
                {
                    "number": 19,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_19_fC9Ebhz.jpg",
                    "products": []
                },
                {
                    "number": 20,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/page_20_31g2059.jpg",
                    "products": []
                },
                {
                    "number": 21,
                    "image_file": "https://interattivo.s3.amazonaws.com/GapcmvcfAb/pages/DeSpar-fine_3GFbivg.png",
                    "products": []
                }
            ]
        }
    }

}

const lefletSwitch = () => {
    return leaflets.despar;
}

export const serverResponse = lefletSwitch();
